export default __webpack_public_path__ + "static/media/discord.d8c3f8ff.svg";